import React, {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import UserLayout from '../util/UserLayout'
import {getUserAddresses} from "../../redux/actions/addressAction"
import AddAddress from "../../components/Address/AddAddress"
import Loader from '../../components/util/Loader'
import DeleteAddress from '../../components/Address/DeleteAddress'

const Addresses = () => {

  const dispatch = useDispatch()
  const {error, addresses} = useSelector(state=>state.address)
  const [loading, setLoading] = useState(true)
  const [selectedAddress, setSelectedAddress] = useState({})

  useEffect(() => {
    if (addresses.length === 0) {
      dispatch(getUserAddresses())
      .then(res=>{
        setLoading(false)
      })
    }
  }, [])

  const handleDeleteAddress = () => {

  }
  

  return (
    <UserLayout>
        {!loading ? <div className="row">
        {addresses.length > 0 ? addresses.map((item, index)=>(
            <div className="col-12 col-lg-6" key={index}>
            {/* Card */}
            <div className="card card-lg bg-light mb-8">
              <div className="card-body">
                <h6 className="mb-6">
                  Shipping Address
                </h6>
                <p className="text-muted mb-0">
                  {item.name} <br />
                  {item.address}, {item.pinCode} <br />
                  {item.state}, {item.country} <br />
                  {item.phoneNumber} <br />
                </p>
                {/* Action */}
                <div className="card-action card-action-right">
                  <a className="btn btn-xs btn-circle btn-white-primary mr-2" href="account-address-edit.html">
                    <i className="bi bi-pencil" />
                  </a>
                  <button className="btn btn-xs btn-circle btn-white-primary" data-toggle="modal" href="#deleteAddressModal" onClick={()=>setSelectedAddress(item)}>
                    <i className="bi bi-x" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )) : <div className='col-12 mb-8 text-center'><h6>No saved Addresses</h6></div>}
        <div className="col-12">
          {/* Button */}
          <button className="btn btn-block btn-lg btn-outline-border" data-toggle="modal" href="#addAddressModal">
            Add Address <i className="bi bi-plus" />
          </button>
        </div>
      </div> : <Loader/>}
      <AddAddress/>
      <DeleteAddress id={selectedAddress._id}/>
    </UserLayout>
  )
}

export default Addresses